import getConfig from 'next/config'

export interface PaymentMethodLike {
  pid?: string | number
  paymentID?: string | number
  paymentName?: string
  name?: string
  shortDescription?: string
  icon?: string
  paymentIcon?: string
}

const config = getConfig()

export const ZIP_PAYMENT_ENABLED =
  config?.publicRuntimeConfig?.zipPaymentEnabled === true

const ZIP_PAYMENT_IDS = new Set(['18', '29'])

export const isZipPaymentMethod = (method: PaymentMethodLike) => {
  const paymentId = method.pid ?? method.paymentID

  if (paymentId !== undefined && ZIP_PAYMENT_IDS.has(String(paymentId))) {
    return true
  }

  return [
    method.paymentName,
    method.name,
    method.shortDescription,
    method.icon,
    method.paymentIcon
  ].some((value) => value?.toLowerCase().includes('zip'))
}

export const filterVisiblePaymentMethods = <T extends PaymentMethodLike>(
  methods: T[] = []
) => {
  if (ZIP_PAYMENT_ENABLED) return methods

  return methods.filter((method) => !isZipPaymentMethod(method))
}
